export default __webpack_public_path__ + "img/5424b543706cf9fc4d6170a14697c32c.svg";